/** Base path for all API endpoints */
export const apiPath = `${process.env.PUBLIC_URL}/api`;
